import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, Loader2 } from 'lucide-react';
import axios from 'axios';
import { useUser } from '@/contexts/UserContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PremiumCancel = () => { 
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useUser();
  const [checking, setChecking] = useState(true);
  const isWeb = !(typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.());

  useEffect(() => {
    const checkSubscriptionAndRoute = async () => {
      try {
        console.log('[PremiumCancel] Checking subscription status...');
        
        // Get user ID from context or localStorage (for email/password users)
        let uid = user?.user_id || user?.id;
        if (!uid) {
          uid = localStorage.getItem('betterhusbandUserId');
        }
        
        if (!uid) {
          console.log('[PremiumCancel] No user ID found, staying on cancel page');
          setChecking(false);
          return;
        }
        
        console.log('[PremiumCancel] Checking subscription for user:', uid);
        const response = await axios.get(`${API}/subscription/status/${uid}`);
        const subscriptionStatus = response?.data?.subscription_status;
        
        console.log('[PremiumCancel] Subscription status:', subscriptionStatus);
        
        if (subscriptionStatus === 'premium' || subscriptionStatus === 'active') {
          console.log('[PremiumCancel] User has active subscription, redirecting');
          navigate(isWeb ? '/download-app' : '/dashboard', { replace: true });
        } else {
          console.log('[PremiumCancel] No active subscription, showing cancel page');
          setChecking(false);
        }
      } catch (err) {
        console.error('[PremiumCancel] Error checking subscription:', err);
        // On error, stay on cancel page
        setChecking(false);
      }
    };
    
    checkSubscriptionAndRoute();
  }, [user, navigate, isWeb]);

  if (checking) {
    return (
      <div className="bg-[#FAFAF9] flex items-center justify-center p-6 pb-safe min-h-screen">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-stone-400 mx-auto mb-4" />
          <p className="text-stone-500">{t('common.loading') || 'Loading...'}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#FAFAF9] flex items-center justify-center p-6 pb-safe">
      <div className="max-w-sm w-full text-center space-y-6">
        {/* Icona */}
        <div className="w-20 h-20 bg-stone-100 rounded-full flex items-center justify-center mx-auto">
          <XCircle className="w-10 h-10 text-stone-400" />
        </div>

        {/* Titolo e messaggio */}
        <div className="space-y-2">
          <h1 className="text-2xl font-serif font-medium text-stone-900">
            {t('premium.cancelTitle')}
          </h1>
          <p className="text-stone-500">{t('premium.cancelMessage')}</p>
        </div>

        {/* Bottoni */}
        <div className="space-y-3">
          {/* Riprova */}
          <button
            data-testid="try-again-btn"
            onClick={() => navigate(-1)}
            className="w-full h-12 rounded-full bg-stone-900 text-white font-medium hover:bg-stone-800 transition-all active:scale-[0.98]"
          >
            {t('premium.tryAgain')}
          </button>

          {/* Torna al paywall */}
          <button
            onClick={() => navigate(isWeb ? '/landing/home' : '/dashboard', { replace: true })}
            className="w-full h-12 rounded-full bg-stone-100 text-stone-700 font-medium hover:bg-stone-200 transition-all active:scale-[0.98] flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            {t(isWeb ? 'premium.backToHome' : 'premium.backToDashboard')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PremiumCancel;
